import { createSlice } from "@reduxjs/toolkit";

/**
 * Estado del workspace Mi Puesto: pestañas activas del cargo y solicitudes
 * de cambio de pestaña. Permite que la navegación inducida (drill-down de
 * dashboards) cambie de PESTAÑA cuando el destino vive dentro del puesto,
 * en vez de sacar al usuario al menú de procesos.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-08-04
 */
const mipuestoSlice = createSlice({
  name: "mipuesto",
  initialState: {
    // [{ PESTORDX, moduleUrl, processUrl }] — vacío = puesto no montado
    pestanas: [],
    // PESTORDX solicitada por la navegación inducida
    tabSolicitada: null,
    // Tracking de operaciones del cargo (Diego 2026-09-24): Ejecutivos → Planeimp, Especialistas → Trackimp.
    // Lo dice el backend (TrackingDelCargo) con el escritorio; null = sin dato, se navega a lo pedido.
    trackingOperaciones: null,
  },
  reducers: {
    setMipuestoPestanas: (state, action) => {
      state.pestanas = action.payload;
    },
    setTabSolicitada: (state, action) => {
      state.tabSolicitada = action.payload;
    },
    setTrackingOperaciones: (state, action) => {
      state.trackingOperaciones = action.payload || null;
    },
    clearMipuesto: (state) => {
      state.pestanas = [];
      state.tabSolicitada = null;
      state.trackingOperaciones = null;
    },
  },
});

export const { setMipuestoPestanas, setTabSolicitada, setTrackingOperaciones, clearMipuesto } = mipuestoSlice.actions;

export const getMipuestoPestanas = (state) => state.mipuesto.pestanas;
export const getTabSolicitada = (state) => state.mipuesto.tabSolicitada;
export const getTrackingOperaciones = (state) => state.mipuesto.trackingOperaciones;

export default mipuestoSlice.reducer;
